import { routes as alocacoes } from './alocacoes';
import { routes as atividadesavaliativas } from './atividadesavaliativas';
import { routes as bncc } from './BNCC';
import { routes as boletimfichaindividual } from './boletimfichaindividual';
import { routes as autorizacoes } from './autorizacoes';
import { routes as conteudolecionado } from './conteudolecionado';
import { routes as crudexemplo } from './crudexemplo';
import { routes as comprovante } from './comprovante';
import { routes as conselhotutelar } from './conselhotutelar';
import { routes as declaracao } from './declaracao';
import { routes as atividadecomplementarprofessor } from './diario/atividadecomplementarprofessor';
import { routes as emissaoDiario } from './diario/emissao';
import { routes as estudante } from './estudante';
import { routes as fechamentoturmas } from './fechamentoturmas';
import { routes as situacoes } from './situacoes';
import { routes as fichadescritiva } from './fichadescritiva';
import { routes as higiene } from './higiene';
import { routes as historicoescolar } from './historicoescolar';
import { routes as estudoscompensatorios } from './estudoscompensatorios';
import { routes as funcionario } from './funcionario';
import { routes as notas } from './notas';
import { routes as conteudocurricular } from './parametros/conteudocurricular';
import { routes as ensino } from './parametros/ensino';
import { routes as planocurricular } from './parametros/planocurricular';
import { routes as quadrohorario } from './quadrohorario';
import { routes as turnos } from './parametros/turnos';
import { routes as ata } from './relatorios/ata';
import { routes as relatorioNotasFaltas } from './relatorios/notasfaltas';
import { routes as relatorioNotasParciaisTotais } from './relatorios/notasparciaistotais';
import { routes as relatorioEstudantesTurma } from './relatorios/turma';
import { routes as conselhodeclasse } from './turma/conselhodeclasse';
import { routes as enturmacao } from './turma/enturmacao';
import { routes as matricula } from './matricula';
import { routes as rematricula } from './rematricula';
import { routes as rematriculasresponsavel } from './rematriculasresponsavel';
import { routes as turmas } from './turma/turmas';
import { routes as ocorrencias } from './ocorrencias';
import { routes as encaminhamentos } from './encaminhamentos';
import { routes as responsavelturma } from './responsavelturma';
import { routes as controlerematricula } from './controlerematricula';
import { routes as mensagens } from './mensagens';
import { routes as filaespera } from './filaespera';
import { routes as cadastrofuncionarios } from './cadastrofuncionarios';

export default [
  {
    path: '/academico',
    name: 'Academico',
    description: 'Módulo Acadêmico',
    children: [
      ...alocacoes,
      ...autorizacoes,
      ...conteudolecionado,
      ...notas,
      ...bncc,
      ...crudexemplo,
      ...comprovante,
      ...conselhotutelar,
      ...declaracao,
      ...fechamentoturmas,
      ...situacoes,
      ...conteudocurricular,
      ...ensino,
      ...historicoescolar,
      ...higiene,
      ...planocurricular,
      ...ata,
      ...relatorioNotasFaltas,
      ...conselhodeclasse,
      ...enturmacao,
      ...matricula,
      ...rematricula,
      ...rematriculasresponsavel,
      ...turmas,
      ...estudante,
      ...atividadesavaliativas,
      ...funcionario,
      ...estudoscompensatorios,
      ...turnos,
      ...atividadecomplementarprofessor,
      ...emissaoDiario,
      ...relatorioEstudantesTurma,
      ...relatorioNotasParciaisTotais,
      ...boletimfichaindividual,
      ...quadrohorario,
      ...fichadescritiva,
      ...ocorrencias,
      ...encaminhamentos,
      ...responsavelturma,
      ...controlerematricula,
      ...mensagens,
      ...filaespera,
      ...cadastrofuncionarios,
    ],
    goesToMenu: true,
  },
];
